/**
 * {
      "mention": 1102,
      "head": "do",
      "HeadToEn": "do",
      "HeadToZh": "做",
      "second": "",
      "second_to_en": "",
      "second_to_zh": "",
      "third": "",
      "third_to_en": "",
      "third_to_zh": "",
      "correlation": 0,
      "avg_sentiment": 3,
      "negative_mentions": 121,
      "neutral_mentions": 936,
      "positive_mentions": 45
  },
 */

import {
  sentimentNumber,
  tryToFixed,
  tryTransNumberDefaultLine,
} from '../../render-helper';

const anchorMaps = {
  origin: 'head',
  zh: 'HeadToZh',
  en: 'HeadToEn',
};

const firstMaps = {
  origin: 'second',
  zh: 'second_to_zh',
  en: 'second_to_en',
};

const secondMaps = {
  origin: 'third',
  zh: 'third_to_zh',
  en: 'third_to_en',
};

function renderSentimentDistribution(item, key) {
  if (!item.mention || !item[key]) {
    return '-';
  }

  if (item[key] === item.mention) {
    return 1;
  }
  return item[key] / item.mention;
}

function renderKeyword(title, params) {
  const { __language } = params;

  return (item) => {
    const anchorKey = anchorMaps[__language] || anchorMaps.origin;
    const firstKey = firstMaps[__language] || firstMaps.origin;
    const secondKey = secondMaps[__language] || secondMaps.origin;

    if (title === 'Correlative Keyword Triplet (Mentions Top 100)') {
      return [item[anchorKey], item[firstKey], item[secondKey]].join(',');
    } else if (title === 'Correlative Keyword Pair (Mentions Top 100)') {
      return [item[anchorKey], item[firstKey]].join(',');
    } else if (title === 'Keyword (Frequency Top 20)') {
      return item[anchorKey];
    } else {
      return '-';
    }
  };
}

export function anchorWordsColumns(params) {
  return [
    {
      header: 'Keyword (Frequency Top 20)',
      renderHelper: [renderKeyword('Keyword (Frequency Top 20)', params)],
      width: 50,
    },

    {
      header: 'Frequency',
      render: 'frequency',
      renderHelper: [tryTransNumberDefaultLine],
    },

    {
      header: 'Mentions',
      render: 'mention',
      renderHelper: [tryTransNumberDefaultLine],
    },
    {
      header: `Rank`,
      render: 'rank',
    },
    {
      header: `Rank`,
      render: 'old_rank',
    },
    {
      header: 'Rank Change',
      render: 'rank_change',
    },
    {
      header: 'Sentiment Distribution (Positive)',
      render: 'positive_mentions',
      renderHelper: [renderSentimentDistribution],
      numFmt: '0.00%',
    },
    {
      header: 'Sentiment Distribution (Neutral)',
      render: 'neutral_mentions',
      renderHelper: [renderSentimentDistribution],
      numFmt: '0.00%',
    },
    {
      header: 'Sentiment Distribution (Negative)',
      render: 'negative_mentions',
      renderHelper: [renderSentimentDistribution],
      numFmt: '0.00%',
    },
    {
      header: 'AVG Sentiment',
      render: 'avg_sentiment',
      renderHelper: [sentimentNumber],
    },
  ];
}

export function firstCorrelationWordsColumns(params) {
  return correlationWordsColumns(
    'Correlative Keyword Pair (Mentions Top 100)',
    params,
  );
}

export function secondCorrelationWordsColumns(params) {
  return correlationWordsColumns(
    'Correlative Keyword Triplet (Mentions Top 100)',
    params,
  );
}

function correlationWordsColumns(keywordTitle, params) {
  return [
    {
      header: keywordTitle,
      renderHelper: [renderKeyword(keywordTitle, params)],
      width: 50,
    },
    {
      header: 'Correlation',
      render: 'correlation',
      renderHelper: [tryToFixed(2), tryTransNumberDefaultLine],
      numFmt: '0.00',
    },
    {
      header: `Co-occurrence Mentions`,
      render: 'mention',
      renderHelpler: [tryTransNumberDefaultLine],
    },

    {
      header: 'Sentiment Distribution (Positive)',
      render: 'positive_mentions',
      renderHelper: [renderSentimentDistribution],
      numFmt: '0.00%',
    },
    {
      header: 'Sentiment Distribution (Neutral)',
      render: 'neutral_mentions',
      renderHelper: [renderSentimentDistribution],
      numFmt: '0.00%',
    },
    {
      header: 'Sentiment Distribution (Negative)',
      render: 'negative_mentions',
      renderHelper: [renderSentimentDistribution],
      numFmt: '0.00%',
    },
    {
      header: 'AVG Sentiment',
      render: 'avg_sentiment',
      renderHelper: [sentimentNumber],
    },
  ];
}
